import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
// import oemApi from "src/api/oemApi";
import ibbApi from "src/api/ibbApi";
import { SUBDOMAIN } from 'src/constants'

const params = {
    "location": "",
    "platform": process.env.REACT_APP_PLATFORM_ID
}

export const fetchSubdomainList = createAsyncThunk(
    "fetchSubdomain",
    () => {
        const LSToken = JSON.parse(`${localStorage.getItem('token')}`);
        let headers: any = {};
        if (LSToken) {
            headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${LSToken.token}`
            }
        }
        const res = ibbApi
            .get(
                `${SUBDOMAIN}`,
                //params,
                {
                    headers: headers
                }
        )
            .then((response) => 
            {
                return response.data.data})
            .catch((error) => error)
        return res
    }
);

const subdomainInitialState = {
    status: "idle",
    data: [],
    error: {},
};

const subdomainListSlice = createSlice({
    name: "subdomainList",
    initialState: subdomainInitialState,
    reducers: {},
    extraReducers: {
        [fetchSubdomainList.pending.type]: (state, action) => {
            state.status = "loading"
            state.data = []
            state.error = {}
        },
        [fetchSubdomainList.fulfilled.type]: (state, action: PayloadAction<any>) => {
            state.status = "success"
            state.data = action.payload
            state.error = {}
        },
        [fetchSubdomainList.rejected.type]: (state, action: PayloadAction<object[]>) => {
            state.status = "error"
            state.data = []
            state.error = action.payload
        },
    },
});

export default subdomainListSlice.reducer;